import { useContext } from 'react';
import { Collapse3dCodeContext } from '../contexts/Collapse3dCodeContext';

// ----------------------------------------------------------------------

const useCollapse3dCode = () => useContext(Collapse3dCodeContext);

export default useCollapse3dCode;
